import React, { PropTypes } from 'react';
import { IntlProvider as RootIntlProvider } from 'react-intl';
import translations from '../lib/translations';

export default function IntlProvider(props) {
  const locale = window.navigator.language || 'en';
  return (
    <RootIntlProvider
      locale={locale}
      messages={translations(locale)}
    >
      {props.children}
    </RootIntlProvider>
  );
}

IntlProvider.propTypes = {
  children: PropTypes.element,
};



// WEBPACK FOOTER //
// ./src/components/IntlProvider.jsx